/* Buscador del encabezado.
 *
 * Al tocar la lupa se abre un panel dentro del mismo header (en celular ocupa
 * toda la pantalla) y los resultados van apareciendo mientras el cliente
 * escribe, sin recargar la página.
 *
 * Los resultados los pinta Shopify: se le pide la sección
 * `predictive-search` a /search/suggest y se pega el HTML tal cual.
 *
 * Si el JavaScript falla, la lupa sigue siendo un enlace a /search y el
 * formulario sigue enviando a la página de resultados. Nada se rompe.
 */
(function () {
  'use strict';

  const panel = document.querySelector('[data-search]');
  if (!panel) return;

  const header = document.querySelector('[data-header]');
  const form = panel.querySelector('form');
  const input = panel.querySelector('[data-search-input]');
  const clearBtn = panel.querySelector('[data-search-clear]');
  const results = panel.querySelector('[data-search-results]');
  const searchUrl = panel.dataset.searchUrl || '/search/suggest';

  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 250;

  let timer = null;
  let controller = null;
  let lastQuery = '';

  function open() {
    panel.hidden = false;
    if (header) {
      // El header escondido está movido con transform, y eso arrastraría al
      // panel de celular aunque sea fixed. Con el buscador abierto, se queda.
      header.classList.remove('is-hidden');
      header.classList.add('is-searching');
    }
    // en celular el panel tapa la pantalla: que no se mueva lo de atrás
    if (window.matchMedia('(max-width: 1199px)').matches) {
      document.body.style.overflow = 'hidden';
    }
    input.focus();
  }

  function close() {
    panel.hidden = true;
    if (header) header.classList.remove('is-searching');
    document.body.style.overflow = '';
    if (controller) controller.abort();
    results.innerHTML = '';
    lastQuery = '';
  }

  function toggleClear() {
    clearBtn.hidden = input.value.length === 0;
  }

  function render(html) {
    // La API devuelve la sección completa envuelta; solo interesa lo de adentro
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const section = parsed.querySelector('#shopify-section-predictive-search');
    results.innerHTML = section ? section.innerHTML : html;
  }

  function search(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    const url =
      searchUrl +
      '?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product,article,page' +
      '&resources[limit]=6' +
      '&section_id=predictive-search';

    fetch(url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(render)
      .catch((error) => {
        if (error.name === 'AbortError') return;
        // Si la búsqueda en vivo falla, al menos queda la salida a /search
        results.innerHTML =
          '<div class="psearch psearch--empty">No pudimos buscar en este momento. ' +
          'Presiona Enter para ver los resultados completos.</div>';
      });
  }

  function onType() {
    toggleClear();
    const query = input.value.trim();

    clearTimeout(timer);

    if (query.length < MIN_CHARS) {
      results.innerHTML = '';
      lastQuery = '';
      return;
    }

    if (query === lastQuery) return;

    timer = setTimeout(function () {
      lastQuery = query;
      search(query);
    }, DEBOUNCE_MS);
  }

  document.querySelectorAll('[data-search-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      // El menú móvil también tiene lupa. Al cerrarlo, su propio listener
      // libera el scroll del body, así que hay que abrir el buscador después.
      const drawer = document.querySelector('.mdrawer[open]');
      if (drawer) {
        drawer.open = false;
        setTimeout(open, 0);
        return;
      }

      open();
    });
  });

  panel.querySelector('[data-search-close]').addEventListener('click', close);

  clearBtn.addEventListener('click', function () {
    input.value = '';
    results.innerHTML = '';
    lastQuery = '';
    toggleClear();
    input.focus();
  });

  input.addEventListener('input', onType);

  // Enter manda a la página de resultados completos
  form.addEventListener('submit', function (event) {
    if (input.value.trim() === '') event.preventDefault();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) close();
  });

  // Clic fuera del panel (solo en escritorio: en celular ocupa todo)
  document.addEventListener('click', function (event) {
    if (panel.hidden) return;
    if (panel.contains(event.target)) return;
    if (event.target.closest('[data-search-open]')) return;
    if (window.matchMedia('(max-width: 1199px)').matches) return;
    close();
  });
})();
